import { Component, OnInit, Input } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import { LangChangeEvent } from '@ngx-translate/core';

@Component({
	selector: 'wncm-form-control-date',
	templateUrl: './form-control-date.component.html',
	styleUrls: ['../form-control.component.scss', './form-control-date.component.scss']
})
export class FormControlDateComponent extends FormControlComponent implements OnInit {
	constructor(private translate: TranslateService, private adapter: DateAdapter<any>) {
		super();
	}

	@Input()
	min;

	@Input()
	max;

	@Input()
	readOnly: boolean;

	@Input()
	showClearButton: boolean;

	@Input()
	requiredField = false;

	@Input()
	inputCanClickable = false;

	ngOnInit() {
		super.ngOnInit();

		if (this.readOnly) {
			this.control.disable();
		}

		this.adapter.setLocale(this.translate.currentLang || this.translate.defaultLang);
		this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
			this.adapter.setLocale(event.lang);
		});
	}
}
